import React from "react";
import { fileUrl } from "@/lib/api";
import { Download, Link as LinkIcon, FileText } from "lucide-react";

function ytId(url) {
  const m = (url || "").match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/))([\w-]{11})/);
  return m ? m[1] : null;
}
function vimeoId(url) {
  const m = (url || "").match(/vimeo\.com\/(?:video\/)?(\d+)/);
  return m ? m[1] : null;
}

export default function ContentBloque({ b, idx }) {
  if (b.tipo === "youtube" && ytId(b.url)) {
    return (
      <div className="player" data-testid={`bloque-youtube-${idx}`}>
        <iframe title={`v${idx}`} src={`https://www.youtube.com/embed/${ytId(b.url)}`} style={{ width: "100%", height: "100%", border: 0 }}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />
      </div>
    );
  }
  if (b.tipo === "vimeo" && vimeoId(b.url)) {
    return (
      <div className="player" data-testid={`bloque-vimeo-${idx}`}>
        <iframe title={`v${idx}`} src={`https://player.vimeo.com/video/${vimeoId(b.url)}`} style={{ width: "100%", height: "100%", border: 0 }}
          allow="autoplay; fullscreen; picture-in-picture" allowFullScreen />
      </div>
    );
  }
  if (b.tipo === "video" && b.file_url) {
    return (
      <div className="player" data-testid={`bloque-video-${idx}`}>
        <video src={fileUrl(b.file_url)} controls playsInline style={{ width: "100%", height: "100%", objectFit: "contain", background: "#000" }} />
      </div>
    );
  }
  if (b.tipo === "imagen" && b.file_url) {
    return <img src={fileUrl(b.file_url)} alt={b.titulo || ""} data-testid={`bloque-imagen-${idx}`} style={{ width: "100%", borderRadius: 12, border: "1px solid var(--line)" }} />;
  }
  if (b.tipo === "pdf" && b.file_url) {
    const url = fileUrl(b.file_url);
    const name = b.titulo || "Documento";
    const isPdf = /\.pdf(\?|#|$)/i.test(name) || /\.pdf(\?|#|$)/i.test(b.file_url);
    if (!isPdf) {
      // Archivos que no son PDF (HTML, ZIP, DOCX…) → tarjeta de descarga
      return (
        <a href={url} target="_blank" rel="noreferrer" download data-testid={`bloque-pdf-${idx}`}
          className="mod" style={{ textDecoration: "none", display: "flex", alignItems: "center", gap: 10, maxWidth: 520 }}>
          <span className="st"><Download size={15} /></span>{name}
          <span style={{ marginLeft: "auto", fontSize: 11, color: "var(--muted)", textTransform: "uppercase" }}>Descargar</span>
        </a>
      );
    }
    return (
      <div data-testid={`bloque-pdf-${idx}`} style={{ width: "100%" }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12, marginBottom: 10, flexWrap: "wrap" }}>
          <span style={{ color: "var(--cream)", fontSize: 14.5, fontWeight: 600, display: "flex", alignItems: "center", gap: 8 }}>
            <FileText size={16} style={{ color: "var(--gold)" }} />{name}
          </span>
          <a className="btn btn-gold btn-sm" href={url} target="_blank" rel="noreferrer" download data-testid={`bloque-pdf-download-${idx}`}>
            <Download size={14} /> Descargar
          </a>
        </div>
        <iframe title={name} src={`${url}#view=FitH&toolbar=1`} className="pdf-frame" data-testid={`bloque-pdf-frame-${idx}`} />
        <a href={url} target="_blank" rel="noreferrer" className="pdf-fallback" data-testid={`bloque-pdf-open-${idx}`}>
          ¿No ves el documento? Pulsa aquí para abrirlo →
        </a>
      </div>
    );
  }
  if (b.tipo === "texto" && b.texto) {
    return <div data-testid={`bloque-texto-${idx}`} style={{ color: "var(--cream)", fontSize: 15, lineHeight: 1.85, fontWeight: 300, whiteSpace: "pre-wrap" }}>{b.texto}</div>;
  }
  if (b.tipo === "enlace" && b.url) {
    return (
      <a href={b.url} target="_blank" rel="noreferrer" download data-testid={`bloque-enlace-${idx}`}
        className="mod" style={{ textDecoration: "none", display: "flex", alignItems: "center", gap: 10, maxWidth: 520 }}>
        <span className="st"><LinkIcon size={15} /></span>{b.titulo || b.url}
        <span style={{ marginLeft: "auto", fontSize: 11, color: "var(--muted)", textTransform: "uppercase" }}>Abrir</span>
      </a>
    );
  }
  return null;
}
